import { combineReducers } from 'redux';
import artistsReducer from '../reducers/artistsReducer';
import comicsReducer from '../reducers/comicsReducer';
import templateReducer from '../reducers/templateReducer';

export default combineReducers({
	artists: artistsReducer,
	comics: comicsReducer,
	template: templateReducer
});



// WEBPACK FOOTER //
// ./src/client/reducers/index.js